const prodConfig = require("./prod");
const devConfig = require("./dev");
const uatConfig = require("./uat");

export default (process.env.NODE_ENV === "production" ? prodConfig : devConfig);

// module.exports = devConfig;
// module.exports = prodConfig;
// module.exports = uatConfig;
